module.exports = __webpack_public_path__ + "static/media/icon-booking-white.173dc371.svg";